import { render, staticRenderFns } from "./CreateNewUser.vue?vue&type=template&id=c4a9c31e&scoped=true&"
import script from "./CreateNewUser.vue?vue&type=script&lang=js&"
export * from "./CreateNewUser.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewUser.vue?vue&type=style&index=0&id=c4a9c31e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a9c31e",
  null
  
)

export default component.exports